// extracted by mini-css-extract-plugin
export default {"cls1":"lnCADaj5LWMosslLESUO","cls2":"GSjGqJYxQnEHDRVp3tds lnCADaj5LWMosslLESUO"};